import { render, staticRenderFns } from "./GlobalSearchSetup.vue?vue&type=template&id=402ba5e7&scoped=true&"
import script from "./GlobalSearchSetup.vue?vue&type=script&lang=js&"
export * from "./GlobalSearchSetup.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSearchSetup.vue?vue&type=style&index=0&id=402ba5e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402ba5e7",
  null
  
)

export default component.exports